import * as api from "services/api";
import { getErrors } from "helpers/error";

export const UPDATE_TAX = "[TAX UPDATE] UPDATE_TAX";
export const UPDATE_TAX_ERROR = "[TAX UPDATE] UPDATE_TAX_ERROR";
export const UPDATE_TAX_SUCCESS = "[TAX UPDATE] UPDATE_TAX_SUCCESS";

export const SET_VALUE = "[TAX UPDATE] SET_VALUE";
export const CLEAR_VALUES = "[TAX UPDATE] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function updateTax(id, model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: UPDATE_TAX
		});

		try {
			const { login } = getState();

			let response = await api.sendPut(`/tax/${id}`, model, {
				Authorization: "Bearer " + login.token
			});

			if (response.ok) {
				let result = await response.json();
				dispatch({
					type: UPDATE_TAX_SUCCESS
				});

				callback && callback(null, result.model);
			} else {
				let result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: UPDATE_TAX_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: UPDATE_TAX_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
